export const ACCESS_TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const AUTH_UPDATE_EVENT = 'auth:update';

export interface AuthUpdateDetail {
  accessToken: string | null;
  refreshToken: string | null;
}

export interface AuthStatePayload {
  accessToken?: string | null;
  refreshToken?: string | null;
  notify?: boolean;
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setAuthState(payload: AuthStatePayload = {}) {
  const { accessToken, refreshToken, notify = true } = payload;

  if (accessToken !== undefined) {
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  }

  if (refreshToken !== undefined) {
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  }

  if (notify) {
    const detail: AuthUpdateDetail = {
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken()
    };

    window.dispatchEvent(new CustomEvent<AuthUpdateDetail>(AUTH_UPDATE_EVENT, { detail }));
  }
}

export function clearAuthState(notify: boolean = true) {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);

  if (notify) {
    const detail: AuthUpdateDetail = {
      accessToken: null,
      refreshToken: null
    };

    window.dispatchEvent(new CustomEvent<AuthUpdateDetail>(AUTH_UPDATE_EVENT, { detail }));
  }
}
